import Vue from 'vue'
import Vuex from 'vuex'

import roleinorganization from './store/modules/roleinorganization/'
import roleinvessel from './store/modules/roleinvessel/'
import userprofile from './store/modules/userprofile/'
import connectagreement from './store/modules/connectagreement/'
import site from './store/modules/site/'
import serviceperiod from './store/modules/connectserviceperiod'
import order from './store/modules/order'
import payment from './store/modules/payment'
import setting from './store/modules/setting'
import volumetoken from './store/modules/connectvolumetoken'
import legalentity from './store/modules/legalentity'

Vue.use(Vuex)

const drawer = {
  state: {
    status: null,
    showPaymentMethods: null
  },
  mutations: {
    drawerSetStatus(state, val) {
      state.status = val
    },
    drawerSetShowPaymentMethods(state, val) {
      state.showPaymentMethods = val
    }
  }
}

const pendingOrders = {
  state: {
    orders: null
  },
  mutations: {
    pendingOrdersSetOrders(state, val) {
      state.orders = val
    }
  }
}

export default new Vuex.Store({
  modules: {
    roleinorganization,
    roleinvessel,
    userprofile,
    connectagreement,
    site,
    serviceperiod,
    order,
    payment,
    setting,
    drawer,
    pendingOrders,
    volumetoken,
    legalentity
  }
})
